import { Component, Input } from '@angular/core';
import CustomerAccountTypeGroup from 'app/customeraccount/CustomerAccountTypeGroup';
import { TabPanelDisplayMode } from 'app/components/enums/TabPanelDisplayMode';
import { PartnerGroupService } from '../../../../services/partner-group.service';

@Component({
  selector: 'app-components-specialist-external-access-read-only',
  templateUrl: './external-access-read-only.component.html'
})
export class ExternalAccessReadOnlyComponent {
  @Input() public customer: Boo.Objects.Customer;

  blog: number[] = CustomerAccountTypeGroup.blog;
  seo: number[] = CustomerAccountTypeGroup.seo;
  website: number[] = CustomerAccountTypeGroup.website;
  tabPanelDisplayMode = TabPanelDisplayMode;

  constructor(public partnerGroupService: PartnerGroupService) { }
}
